import { createApp } from 'vue'
import App from '~/App.vue'
import { registerPlugins } from '@core/utils/plugins'
import i18nPlugin, { getI18n, mergeRemote } from '~/plugins/i18n'
import $api from '~/utils/api'
import { createHead } from '@unhead/vue/client'
import * as Sentry from '@sentry/vue'
import { router } from '~/plugins/1.router/index'

import '@core-scss/template/index.scss'
import '@styles/styles.scss'

async function loadTranslations() {
    try {
        const { data: dataEn } = await $api.get(`/translations/en`)
        const { data: dataHe } = await $api.get(`/translations/he`)

        if (dataEn?.success && dataEn?.data) {
            mergeRemote('en', dataEn.data)
        }
        if (dataHe?.success && dataHe?.data) {
            mergeRemote('he', dataHe.data)
            return true
        }
    } catch (error) {
        console.error('Error loading translations:', error)
    }
    return false
}

async function bootstrap() {
    const app = createApp(App)

    Sentry.init({
        app,
        dsn: "https://cca22cad564ba1aa2b6eea6d9790bf17@o4509162296180736.ingest.de.sentry.io/4510109113319504",
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration({ router }),
            Sentry.replayIntegration()
        ],
        // Tracing
        tracesSampleRate: 1.0, // Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/dev\.polyhen\.com\/api/, /^https:\/\/dev\.polyhen\.com/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
        // Logs
        enableLogs: true
    });

    const head = createHead()
    // 1) Регистрируем плагины
    registerPlugins(app)

    // 2) Подключаем i18n
    app.use(i18nPlugin)
    getI18n()

    // 3) Загружаем переводы с Laravel
    await loadTranslations()

    app.use(head)

    // 4) Монтируем приложение
    app.mount('#app')
}

bootstrap()
